import React, { useState } from 'react'
import { trackEvent } from 'utils/analytics'

export default function TeamFAQSection({ faq, colors, translations }) {
  const [expandedFaq, setExpandedFaq] = useState(null)

  // Support both array format and { items: [] } format
  const items = Array.isArray(faq) ? faq : (faq?.items || [])

  if (!items || items.length === 0) return null

  return (
    <section className="py-8 border-t border-gray-200">
      <div className="mb-6">
        <h2 className="text-[22px] font-semibold" style={{ color: '#222222' }}>{translations?.title || 'FAQ'}</h2>
        <p className="text-sm mt-1" style={{ color: '#717171' }}>{translations?.subtitle || 'Common questions about our courses'}</p>
      </div>
      <div className="space-y-3">
          {items.map((item, idx) => (
            <div
              key={idx}
              className="border border-gray-100 rounded-xl overflow-hidden hover:shadow-sm transition-all"
            >
              <button
                onClick={() => {
                  if (expandedFaq !== idx) trackEvent('faq_expand', { question: item.question })
                  setExpandedFaq(expandedFaq === idx ? null : idx)
                }}
                className="w-full px-5 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-medium" style={{ color: '#222222' }}>{item.question}</span>
                <svg
                  className={`w-5 h-5 text-gray-400 transition-transform ${
                    expandedFaq === idx ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {expandedFaq === idx && (
                <div className="px-5 pb-4 border-t border-gray-100 pt-3" style={{ color: '#717171' }}>
                  {item.answer}
                </div>
              )}
            </div>
          ))}
      </div>
    </section>
  )
}
